import React, { useState, useEffect, useCallback, useMemo } from 'react';
import {
  Card, Tabs, Table, Button, Space, Select, Input, Tag, Checkbox,
  message, Row, Col, Modal, Spin, Empty, Alert,
  Divider,
} from 'antd';
import {
  SendOutlined, SearchOutlined,
  EyeOutlined, ReloadOutlined,
} from '@ant-design/icons';
import { scenarioAPI, scenarioSiteAdminAPI } from '../services/api';

const { Option } = Select;
const { TextArea } = Input;

const TEMPLATES = [
  {
    key: 'product',
    label: '商品通知',
    subject: '【{{brand}}】新商品上架通知',
    body: `<html>
<body style="font-family:'Microsoft JhengHei','Noto Sans TC',Arial,sans-serif;margin:0;padding:0;background:#f5f5f5;">
<div style="max-width:680px;margin:20px auto;background:#fff;border-radius:8px;overflow:hidden;box-shadow:0 2px 8px rgba(0,0,0,0.1);">
  <div style="background-color:{{color}};padding:30px;text-align:center;">
    <h1 style="color:#ffffff;margin:0;font-size:22px;">{{brand}}</h1>
    <p style="color:rgba(255,255,255,0.8);margin:8px 0 0;font-size:14px;">新商品上架通知</p>
  </div>
  <div style="padding:30px;">
    <p style="font-size:16px;">您好！</p>
    <p style="line-height:1.8;">我們很高興地通知您，我們已新增商品至線上目錄。歡迎前往我們的網站瀏覽最新商品資訊。</p>
    <table width="100%" cellpadding="0" cellspacing="0" border="0" style="margin:30px 0;">
      <tr><td align="center">
        <table cellpadding="0" cellspacing="0" border="0">
          <tr>
            <td align="center" bgcolor="{{color}}" style="border-radius:6px;" height="48">
              <a href="{{siteUrl}}" target="_blank" style="display:inline-block;padding:14px 40px;color:#ffffff;font-size:16px;font-weight:bold;text-decoration:none;">瀏覽商品</a>
            </td>
          </tr>
        </table>
      </td></tr>
    </table>
    <p style="font-size:14px;color:#666;">如有任何問題，歡迎隨時與我們聯繫。</p>
    <p style="margin-top:20px;"><strong>{{brand}} 敬上</strong></p>
  </div>
  <div style="background:#f5f5f5;padding:16px;text-align:center;font-size:12px;color:#999;">
    此信件由系統自動發送。
  </div>
</div>
</body>
</html>`,
  },
  {
    key: 'event',
    label: '活動邀請',
    subject: '【{{brand}}】誠摯邀請您參加活動',
    body: `<html>
<body style="font-family:'Microsoft JhengHei','Noto Sans TC',Arial,sans-serif;margin:0;padding:0;background:#f5f5f5;">
<div style="max-width:680px;margin:20px auto;background:#fff;border-radius:8px;overflow:hidden;box-shadow:0 2px 8px rgba(0,0,0,0.1);">
  <div style="background-color:{{color}};padding:30px;text-align:center;">
    <h1 style="color:#ffffff;margin:0;font-size:22px;">{{brand}}</h1>
    <p style="color:rgba(255,255,255,0.8);margin:8px 0 0;font-size:14px;">活動邀請</p>
  </div>
  <div style="padding:30px;">
    <p style="font-size:16px;">您好！</p>
    <p style="line-height:1.8;">我們誠摯邀請您參加即將舉辦的活動。活動詳細資訊與報名，請前往我們的網站。</p>
    <table width="100%" cellpadding="0" cellspacing="0" border="0" style="margin:30px 0;">
      <tr><td align="center">
        <table cellpadding="0" cellspacing="0" border="0">
          <tr>
            <td align="center" bgcolor="{{color}}" style="border-radius:6px;" height="48">
              <a href="{{siteUrl}}/events" target="_blank" style="display:inline-block;padding:14px 40px;color:#ffffff;font-size:16px;font-weight:bold;text-decoration:none;">查看活動</a>
            </td>
          </tr>
        </table>
      </td></tr>
    </table>
    <p style="font-size:14px;color:#666;">期待您的參與！</p>
    <p style="margin-top:20px;"><strong>{{brand}} 敬上</strong></p>
  </div>
  <div style="background:#f5f5f5;padding:16px;text-align:center;font-size:12px;color:#999;">
    此信件由系統自動發送。
  </div>
</div>
</body>
</html>`,
  },
  {
    key: 'followup',
    label: '跟進通知',
    subject: '【{{brand}}】感謝您的詢價',
    body: `<html>
<body style="font-family:'Microsoft JhengHei','Noto Sans TC',Arial,sans-serif;margin:0;padding:0;background:#f5f5f5;">
<div style="max-width:680px;margin:20px auto;background:#fff;border-radius:8px;overflow:hidden;box-shadow:0 2px 8px rgba(0,0,0,0.1);">
  <div style="background-color:{{color}};padding:30px;text-align:center;">
    <h1 style="color:#ffffff;margin:0;font-size:22px;">{{brand}}</h1>
    <p style="color:rgba(255,255,255,0.8);margin:8px 0 0;font-size:14px;">感謝您的詢價</p>
  </div>
  <div style="padding:30px;">
    <p style="font-size:16px;">您好！</p>
    <p style="line-height:1.8;">感謝您對我們商品的關注與詢價。我們已收到您的需求，業務團隊會盡快與您聯繫。</p>
    <div style="background:#f9f9f9;padding:16px;border-radius:6px;margin:20px 0;border-left:4px solid {{color}};">
      若有更多問題，歡迎隨時透過網站與我們聯繫。
    </div>
    <table width="100%" cellpadding="0" cellspacing="0" border="0" style="margin:30px 0;">
      <tr><td align="center">
        <table cellpadding="0" cellspacing="0" border="0">
          <tr>
            <td align="center" bgcolor="{{color}}" style="border-radius:6px;" height="48">
              <a href="{{siteUrl}}/contact" target="_blank" style="display:inline-block;padding:14px 40px;color:#ffffff;font-size:16px;font-weight:bold;text-decoration:none;">聯絡我們</a>
            </td>
          </tr>
        </table>
      </td></tr>
    </table>
    <p style="margin-top:20px;"><strong>{{brand}} 敬上</strong></p>
  </div>
  <div style="background:#f5f5f5;padding:16px;text-align:center;font-size:12px;color:#999;">
    此信件由系統自動發送。
  </div>
</div>
</body>
</html>`,
  },
  {
    key: 'custom',
    label: '空白範本',
    subject: '',
    body: '',
  },
];

const SOURCE_LABELS = {
  inquiry: '詢價',
  event: '活動報名',
};
const SOURCE_FILTER_OPTIONS = [
  { value: 'inquiry', label: '詢價客戶' },
  { value: 'event', label: '活動報名' },
];

export default function CustomerEmailPage({ currentUser }) {
  const [scenarios, setScenarios] = useState([]);
  const [selectedScenario, setSelectedScenario] = useState(null);
  const [siteConfigs, setSiteConfigs] = useState({});
  const [loading, setLoading] = useState(true);

  const [recipients, setRecipients] = useState([]);
  const [selectedKeys, setSelectedKeys] = useState([]);
  const [recipientLoading, setRecipientLoading] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [sourceFilter, setSourceFilter] = useState([]);

  const [template, setTemplate] = useState('product');
  const [subject, setSubject] = useState('');
  const [htmlBody, setHtmlBody] = useState('');
  const [sending, setSending] = useState(false);
  const [confirmVisible, setConfirmVisible] = useState(false);

  const [history, setHistory] = useState([]);
  const [historyLoading, setHistoryLoading] = useState(false);
  const [activeTab, setActiveTab] = useState('compose');

  useEffect(() => {
    (async () => {
      try {
        const res = await scenarioAPI.list();
        const list = res.data || [];
        setScenarios(list);
        const configs = {};
        for (const sc of list) {
          try {
            const cfgRes = await scenarioSiteAdminAPI.getSiteConfig(sc.id);
            configs[sc.id] = cfgRes.data;
          } catch { /* no config */ }
        }
        setSiteConfigs(configs);
        if (list.length > 0) {
          setSelectedScenario(list[0].id);
        }
      } catch { /* ignore */ }
      setLoading(false);
    })();
  }, []);

  const getSiteInfo = useCallback(() => {
    if (!selectedScenario) return {};
    const cfg = siteConfigs[selectedScenario];
    const sc = scenarios.find(s => s.id === selectedScenario);
    return {
      brand: cfg?.brand_name || sc?.name || '',
      color: cfg?.brand_color || '#1890ff',
      slug: cfg?.slug || '',
      siteUrl: cfg?.slug ? `${window.location.origin}/s/${cfg.slug}` : '',
      contactEmail: cfg?.contact_email || '',
    };
  }, [selectedScenario, siteConfigs, scenarios]);

  const applyTemplate = useCallback((key) => {
    const tmpl = TEMPLATES.find(t => t.key === key);
    if (!tmpl) return;
    const info = getSiteInfo();
    const fillVars = (str) =>
      str.replace(/\{\{brand\}\}/g, info.brand)
         .replace(/\{\{color\}\}/g, info.color)
         .replace(/\{\{siteUrl\}\}/g, info.siteUrl);
    setSubject(fillVars(tmpl.subject));
    setHtmlBody(fillVars(tmpl.body));
  }, [getSiteInfo]);

  const loadRecipients = useCallback(() => {
    if (!selectedScenario) return;
    setRecipientLoading(true);
    scenarioSiteAdminAPI.getSiteRecipients(selectedScenario)
      .then(res => {
        const list = res.data || [];
        setRecipients(list);
        setSelectedKeys(list.map(r => r.email));
      })
      .catch(() => setRecipients([]))
      .finally(() => setRecipientLoading(false));
  }, [selectedScenario]);

  const loadHistory = useCallback(() => {
    if (!selectedScenario) return;
    setHistoryLoading(true);
    scenarioSiteAdminAPI.getSiteEmailHistory(selectedScenario)
      .then(res => setHistory(res.data || []))
      .catch(() => setHistory([]))
      .finally(() => setHistoryLoading(false));
  }, [selectedScenario]);

  useEffect(() => {
    if (!selectedScenario) return;
    setSelectedKeys([]);
    setSearchText('');
    setSourceFilter([]);
    loadRecipients();
    loadHistory();
    applyTemplate(template);
  }, [selectedScenario]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleScenarioChange = (id) => {
    setSelectedScenario(id);
  };

  const handleTemplateChange = (key) => {
    setTemplate(key);
    applyTemplate(key);
  };

  const filteredRecipients = useMemo(() => {
    let list = recipients;
    if (sourceFilter.length > 0) {
      list = list.filter(r => (r.sources || []).some(s => sourceFilter.includes(s)));
    }
    if (searchText.trim()) {
      const kw = searchText.trim().toLowerCase();
      list = list.filter(r =>
        (r.name || '').toLowerCase().includes(kw) ||
        (r.email || '').toLowerCase().includes(kw) ||
        (r.company || '').toLowerCase().includes(kw)
      );
    }
    return list;
  }, [recipients, sourceFilter, searchText]);

  const allVisibleSelected = useMemo(() => {
    if (filteredRecipients.length === 0) return false;
    return filteredRecipients.every(r => selectedKeys.includes(r.email));
  }, [filteredRecipients, selectedKeys]);

  const handleSelectAll = (checked) => {
    if (checked) {
      const filteredEmails = filteredRecipients.map(r => r.email);
      setSelectedKeys(prev => [...new Set([...prev, ...filteredEmails])]);
    } else {
      const filteredEmails = new Set(filteredRecipients.map(r => r.email));
      setSelectedKeys(prev => prev.filter(e => !filteredEmails.has(e)));
    }
  };

  const previewHtml = useMemo(() => htmlBody, [htmlBody]);

  const recipientCount = selectedKeys.length;

  const handleSendClick = () => {
    if (!selectedScenario) { message.warning('請先選擇情境'); return; }
    if (recipientCount === 0) { message.warning('請先選擇收件人'); return; }
    if (!subject.trim()) { message.warning('請輸入郵件主旨'); return; }
    if (!htmlBody.trim()) { message.warning('請輸入郵件內容'); return; }
    setConfirmVisible(true);
  };

  const handleSend = async () => {
    setConfirmVisible(false);
    setSending(true);
    try {
      const selectedRecipients = recipients
        .filter(r => selectedKeys.includes(r.email))
        .map(r => ({ email: r.email, name: r.name || '' }));

      const res = await scenarioSiteAdminAPI.sendSiteEmail(selectedScenario, {
        subject,
        html_body: htmlBody,
        recipients: selectedRecipients,
        campaign_name: subject,
      });
      message.success(`發送完成，共寄出 ${res.data.sent} 封`);
      setSelectedKeys([]);
      loadHistory();
    } catch (e) {
      message.error('發送失敗: ' + (e.message || ''));
    } finally {
      setSending(false);
    }
  };

  if (loading) {
    return <div style={{ textAlign: 'center', padding: 80 }}><Spin size="large" /></div>;
  }

  if (scenarios.length === 0) {
    return (
      <Card style={{ textAlign: 'center', padding: 40 }}>
        <Empty description="尚未建立行銷情境，請先建立情境才能使用信件發送功能" />
      </Card>
    );
  }

  const info = getSiteInfo();

  const recipientColumns = [
    {
      title: '公司 / 聯絡人', key: 'company', ellipsis: true,
      render: (_, record) => (
        <div>
          <div style={{ fontWeight: 500, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
            {record.company || '-'}
          </div>
          <div style={{ fontSize: 12, color: '#888' }}>{record.name || '-'}</div>
        </div>
      ),
    },
    { title: 'Email', dataIndex: 'email', key: 'email', ellipsis: true },
    {
      title: '來源', key: 'sources', width: 110, align: 'center',
      render: (_, record) => (
        <Space size={2} wrap>
          {(record.sources || []).map(s => (
            <Tag key={s} color={s === 'inquiry' ? 'blue' : 'purple'} style={{ margin: 0 }}>
              {SOURCE_LABELS[s] || s}
            </Tag>
          ))}
        </Space>
      ),
    },
  ];

  const historyColumns = [
    { title: '主旨', dataIndex: 'subject', key: 'subject', ellipsis: true },
    {
      title: '收件人數', dataIndex: 'email_version', key: 'count', width: 100,
      render: (v) => v ? `${v} 人` : '-',
    },
    {
      title: '狀態', dataIndex: 'status', key: 'status', width: 80,
      render: (s) => {
        const map = { sent: { color: 'green', text: '成功' }, sending: { color: 'processing', text: '發送中' }, draft: { color: 'default', text: '草稿' } };
        const info = map[s] || { color: 'default', text: s || '-' };
        return <Tag color={info.color}>{info.text}</Tag>;
      },
    },
    {
      title: '發送時間', dataIndex: 'sent_at', key: 'sent_at', width: 180,
      render: (v) => v ? new Date(v).toLocaleString('zh-TW') : '-',
    },
  ];

  const renderComposeTab = () => (
    <Row gutter={16}>
      {/* Left: Editor */}
      <Col xs={24} lg={14}>
        <Alert
          type="info"
          showIcon
          style={{ marginBottom: 16, borderRadius: 8 }}
          message={
            <span>
              寄件者：<strong>{info.brand}</strong>
              {info.contactEmail && <> ({info.contactEmail})</>}
            </span>
          }
        />

        <Card size="small" style={{ marginBottom: 16 }}>
          <Space>
            <span style={{ fontWeight: 500 }}>選擇範本：</span>
            <Select
              value={template}
              onChange={handleTemplateChange}
              style={{ width: 280 }}
            >
              {TEMPLATES.map(t => (
                <Option key={t.key} value={t.key}>{t.label}</Option>
              ))}
            </Select>
          </Space>
        </Card>

        <Card title="郵件內容" style={{ marginBottom: 16 }}>
          <Space direction="vertical" style={{ width: '100%' }} size="middle">
            <div>
              <label style={{ fontWeight: 500, display: 'block', marginBottom: 4 }}>主旨</label>
              <Input
                placeholder="輸入郵件主旨"
                value={subject}
                onChange={e => setSubject(e.target.value)}
                size="large"
              />
            </div>
            <div>
              <label style={{ fontWeight: 500, display: 'block', marginBottom: 4 }}>HTML 內容</label>
              <TextArea
                placeholder="輸入 HTML 郵件內容..."
                value={htmlBody}
                onChange={e => setHtmlBody(e.target.value)}
                rows={16}
                style={{ fontFamily: 'monospace', fontSize: 13 }}
              />
            </div>
          </Space>
        </Card>
      </Col>

      {/* Right: Preview + Recipients + Send */}
      <Col xs={24} lg={10}>
        <Card
          title={<Space><EyeOutlined /> 預覽</Space>}
          style={{ marginBottom: 16 }}
        >
          {subject && (
            <div style={{ marginBottom: 8 }}>
              <strong>主旨：</strong> {subject}
            </div>
          )}
          <Divider style={{ margin: '8px 0' }} />
          <div
            style={{
              border: '1px solid #d9d9d9', borderRadius: 4, padding: 0,
              minHeight: 200, maxHeight: 500, overflow: 'auto', backgroundColor: '#fff',
            }}
            dangerouslySetInnerHTML={{ __html: previewHtml || '<p style="color:#ccc;padding:16px">在左側輸入 HTML 內容後即可預覽</p>' }}
          />
        </Card>

        <Card title="收件人設定" style={{ marginBottom: 16 }}>
          <Space direction="vertical" style={{ width: '100%' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <Checkbox
                checked={allVisibleSelected}
                indeterminate={selectedKeys.length > 0 && !allVisibleSelected}
                onChange={e => handleSelectAll(e.target.checked)}
              >
                全選 ({filteredRecipients.length} 人)
              </Checkbox>
              <Tag color="blue" style={{ fontSize: 14 }}>已選：{recipientCount} / {recipients.length} 人</Tag>
            </div>
            <Input
              prefix={<SearchOutlined style={{ color: '#bfbfbf' }} />}
              placeholder="搜尋公司名稱、聯絡人、Email..."
              value={searchText}
              onChange={e => setSearchText(e.target.value)}
              allowClear
            />
            <div>
              <label style={{ display: 'block', marginBottom: 4, fontSize: 13 }}>依來源篩選顯示：</label>
              <Select
                mode="multiple"
                placeholder="全部來源"
                value={sourceFilter}
                onChange={vals => setSourceFilter(vals)}
                style={{ width: '100%' }}
                allowClear
              >
                {SOURCE_FILTER_OPTIONS.map(opt => (
                  <Option key={opt.value} value={opt.value}>{opt.label}</Option>
                ))}
              </Select>
            </div>
            {recipientLoading ? (
              <div style={{ textAlign: 'center', padding: 32 }}><Spin /></div>
            ) : (
              <Table
                columns={recipientColumns}
                dataSource={filteredRecipients}
                rowKey="email"
                size="small"
                pagination={{ pageSize: 10, showTotal: (t) => `共 ${t} 筆` }}
                rowSelection={{
                  selectedRowKeys: selectedKeys,
                  onChange: (keys) => {
                    const filteredEmails = new Set(filteredRecipients.map(r => r.email));
                    const kept = selectedKeys.filter(e => !filteredEmails.has(e));
                    setSelectedKeys([...kept, ...keys]);
                  },
                }}
              />
            )}
          </Space>
        </Card>

        <Button
          type="primary"
          icon={<SendOutlined />}
          size="large"
          block
          loading={sending}
          disabled={!selectedScenario || !subject.trim() || !htmlBody.trim() || recipientCount === 0}
          onClick={handleSendClick}
          style={{
            height: 48,
            borderRadius: 8,
            fontWeight: 600,
            fontSize: 16,
            background: recipientCount > 0 ? `linear-gradient(135deg, ${info.color}, #36cfc9)` : undefined,
            border: 'none',
          }}
        >
          發送郵件 ({recipientCount} 人)
        </Button>
      </Col>
    </Row>
  );

  const renderHistoryTab = () => (
    <Card
      title="發信記錄"
      extra={
        <Button icon={<ReloadOutlined />} onClick={loadHistory} disabled={!selectedScenario}>
          重新整理
        </Button>
      }
    >
      <Table
        columns={historyColumns}
        dataSource={history}
        rowKey="id"
        loading={historyLoading}
        size="small"
        pagination={{ pageSize: 20, showTotal: (t) => `共 ${t} 筆` }}
      />
    </Card>
  );

  const tabItems = [
    { key: 'compose', label: '撰寫郵件', children: renderComposeTab() },
    { key: 'history', label: `發送記錄 (${history.length})`, children: renderHistoryTab() },
  ];

  return (
    <div style={{ padding: 24 }}>
      <h2 style={{ marginBottom: 16 }}>信件發送</h2>

      <Card style={{ marginBottom: 16 }}>
        <Space>
          <span style={{ fontWeight: 500 }}>選擇情境：</span>
          <Select
            value={selectedScenario}
            onChange={handleScenarioChange}
            style={{ width: 400 }}
            allowClear
          >
            {scenarios.map(sc => (
              <Option key={sc.id} value={sc.id}>
                {siteConfigs[sc.id]?.brand_name || sc.name}
              </Option>
            ))}
          </Select>
        </Space>
      </Card>

      <Tabs items={tabItems} activeKey={activeTab} onChange={setActiveTab} />

      <Modal
        title="確認發送"
        open={confirmVisible}
        onOk={handleSend}
        onCancel={() => setConfirmVisible(false)}
        okText="確認發送"
        cancelText="取消"
        okButtonProps={{ danger: true }}
      >
        <p>即將發送郵件：</p>
        <ul>
          <li><strong>寄件者：</strong>{info.brand}{info.contactEmail && ` (${info.contactEmail})`}</li>
          <li><strong>情境：</strong>{info.brand}</li>
          <li><strong>主旨：</strong>{subject}</li>
          <li><strong>收件人數：</strong>{recipientCount} 人</li>
        </ul>
        <p style={{ color: '#ff4d4f' }}>發送後無法撤回，請確認內容無誤。</p>
      </Modal>
    </div>
  );
}
